<template>
  <footer>
    <router-link to="/"><span><i data-feather="headphones"></i> Llamadas</span></router-link>
    <router-link to="/monitoreo"><span><i data-feather="phone-outgoing"></i> Monitoreo</span></router-link>
    <a href="javascript:void(0)" @click="logout()"><span><i data-feather="log-out"></i> Cerrar Sesión</span></a>
  </footer>
</template>

<script>
import feather from 'feather-icons';


export default {
  name: 'FooterNav',
  props: {
    msg: String
  },
  mounted(){
    feather.replace();
  },
  methods: {
    logout(){
      if(confirm("¿Desea cerrar su sesión activa?")){
        localStorage.removeItem("userToken");
        this.$router.push({ path: '/login' });
        this.$root.setLogged(false,null);
      }
    },
  },
}
</script>

<style scoped>
footer { box-shadow:0px 0px 15px rgba(0,0,0,.35); min-height: 61px; background-color: #22252a; position:fixed; bottom:0; width:100%;}
footer a { color:#fff; display:inline-block;width:33.33%; text-align: center; font-size:11px; text-transform: uppercase; letter-spacing: 1px; }
footer a.router-link-active { color:#00b589; }
footer a span {display:block; padding:10px 0px;}
footer a svg { width: 16px; height: 16px; display: block; margin:auto; margin-bottom:8px;}
footer a:first-child { border-right: #000 solid 1px;}
footer a:last-child { border-left: #000 solid 1px;}

</style>
